import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { I18nStateType } from '@redux/types'
import { I18nType } from '@schemas'

// initial state
const initialState: I18nStateType = {
	supportedLanguageList: ['ko', 'en', 'zh-CN'],
	updateI18n: {
		id: '',
		tableName: '',
		tableId: '',
		menuId: '',
		isoLanguageCode: '',
		title: '',
		value: '',
	},
}

const slice = createSlice({
	name: 'i18n',
	initialState,
	reducers: {
		SUPPORTED_LANGUAGE_LIST: (state: I18nStateType, action: PayloadAction<string[]>) => {
			state.supportedLanguageList = action.payload
		},
		UPDATE_I18N: (state: I18nStateType, action: PayloadAction<I18nType>) => {
			state.updateI18n = action.payload
		},
	},
})

export const i18nActions = slice.actions
export default slice.reducer
